import { Log } from "@swivl-mono/types";
import debug from "debug";
import pino from "pino";

import { Env } from "../Env/Env.Helper";

export function warn(message?: any, ...optionalParams: any[]) {
  if (message && optionalParams && optionalParams.length > 0) {
    console.warn("⚠️", message, optionalParams);
  } else if (message) {
    console.warn("⚠️", message);
  } else if (optionalParams && optionalParams.length > 0) {
    console.warn("⚠️", optionalParams);
  } else {
    console.warn("⚠️");
  }
}

// For significant messages that are not problems
export function notice(message?: any, ...optionalParams: any[]) {
  if (message && optionalParams && optionalParams.length > 0) {
    console.info("🔷", message, optionalParams);
  } else if (message) {
    console.info("🔷", message);
  } else if (optionalParams && optionalParams.length > 0) {
    console.info("🔷", optionalParams);
  } else {
    console.info("🔷");
  }
}

export class TimeLog {
  static time = console.time;
  static timeEnd = console.timeEnd;
  static timeLog = console.timeLog;
}

export interface SwivlLogger extends debug.Debugger {
  error: debug.Debugger;
  warn: debug.Debugger;
}

export function CreateLogger(log: Log | string, subType?: string) {
  const scope = subType ? `${log}:${subType}` : log;
  const logger = debug(scope) as SwivlLogger;

  logger.error = debug(`${scope}:error`);
  logger.warn = debug(`${scope}:warn`);

  return logger;
}

export function createLoggerV2(namespace: Log | string, _?: string) {
  const loggerOpts = {
    name: namespace,
    level: process?.env?.["LOG_LEVEL"] || "debug",
    // pino only serializes Errors under the "err" key by default; many call sites use
    // { error } — without this, message/stack are non-enumerable and serialize as {}
    serializers: { error: pino.stdSerializers.err }
  };

  if (Env.isBrowser) {
    return pino({
      ...loggerOpts,
      browser: {
        write: {
          info: console.log,
          warn: console.warn,
          error: console.error,
          debug: console.debug
        }
      }
    });
  }

  if (Env.isLocalContext || Env.isTestContext) {
    return pino({
      ...loggerOpts,
      transport: {
        target: "pino-pretty",
        options: {
          colorize: true
        }
      }
    });
  }

  return pino({
    ...loggerOpts,
    // Datadog only maps status from string level labels ("error"), not pino's numeric levels (50)
    formatters: {
      level: (label: string): { level: string } => ({ level: label })
    }
  });
}
